/**
 * フィードバック関連のサービス
 *
 * 検索結果へのフィードバック（👍👎）をFirestoreに保存
 */

import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

/**
 * 検索フィードバックを保存
 *
 * @param {string} userId - ユーザーID
 * @param {string} query - 検索クエリ
 * @param {string} result - 検索結果（要約テキスト）
 * @param {'good' | 'bad'} rating - 評価
 * @returns {Promise<string>} 保存されたドキュメントID
 */
export async function saveSearchFeedback(userId, query, result, rating) {
  try {
    const feedbackRef = collection(db, 'search_feedback');
    const docRef = await addDoc(feedbackRef, {
      userId,
      query,
      result,
      rating,
      timestamp: serverTimestamp()
    });

    console.log('[KnoVelo] フィードバックを保存しました:', docRef.id);
    return docRef.id;
  } catch (error) {
    console.error('[KnoVelo] フィードバック保存エラー:', error);
    throw error;
  }
}

/**
 * 検索履歴を保存
 *
 * @param {string} userId - ユーザーID
 * @param {string} query - 検索クエリ
 * @param {number} resultCount - 検索結果の件数
 * @returns {Promise<string>} 保存されたドキュメントID
 */
export async function saveSearchHistory(userId, query, resultCount) {
  try {
    const historyRef = collection(db, 'search_history');
    const docRef = await addDoc(historyRef, {
      userId,
      query,
      resultCount,
      timestamp: serverTimestamp()
    });

    console.log('[KnoVelo] 検索履歴を保存しました:', docRef.id);
    return docRef.id;
  } catch (error) {
    console.error('[KnoVelo] 検索履歴保存エラー:', error);
    // 検索履歴の保存失敗はユーザー体験に影響しないため、エラーをスローしない
  }
}

/**
 * Thoth会話履歴を保存
 *
 * @param {string} userId - ユーザーID
 * @param {'user' | 'thoth'} role - 発言者
 * @param {string} message - メッセージ内容
 * @returns {Promise<string>} 保存されたドキュメントID
 */
export async function saveConversation(userId, role, message) {
  try {
    const conversationRef = collection(db, 'thoth_conversations');
    const docRef = await addDoc(conversationRef, {
      userId,
      role,
      message,
      timestamp: serverTimestamp()
    });

    console.log('[KnoVelo] 会話履歴を保存しました:', docRef.id);
    return docRef.id;
  } catch (error) {
    console.error('[KnoVelo] 会話履歴保存エラー:', error);
    // 会話履歴の保存失敗はユーザー体験に影響しないため、エラーをスローしない
  }
}
